import React from 'react';
import { ReactComponent as Pdf } from '../../assets/images/icons/pdf.svg';

export default function PdfIcon(props) {
  return (
    <Pdf {...props} className={'icon'} />
  );
}
